import { AuthenticationActions } from '../models/authentication-actions.enum';

export class ValidateUserDTO {
    userName: string = '';
    password: string = '';
}


export class ConfirmEmail {
    Email: string = '';
}


export class ChangePassword {
    Email: string = '';
    ConfirmPassword: string = '';
    Password: string = '';
}

export class  DocumentModel {
  ProcessName?: string;
  AttachmentFor?: string;
  AttachmentId?: string;
  ProcessID?: string;
  ExpiryDate?: string;
  DocumentExpiryDate?: Date;
  AdditionalDetails?: string;
  ApplicationId?: string;
  Name?: string;
  FilePath?: string;
  FileContent?: string;
  RecId?: number;
  IsIntegrated?: boolean;
  MimeType?: string;
}



export class DocumentsMaster {
  additionalDetailsRequired?: boolean; // Maps to AdditionalDetailsRequired
  allowMultipleDocs?: boolean; // Maps to AllowMultipleDocs
  checkBoxRequired?: boolean; // Maps to CheckBoxRequired
  documentName?: string; // Maps to DocumentName
  expirationDate?: boolean; // Maps to ExpirationDate
  expirationDateMandatory?: boolean; // Maps to ExpirationDateMandatory
  fieldHint?: string; // Maps to FieldHint
  mandatory?: boolean; // Maps to Mandatory
  position?: number; // Maps to Position
  section?: string; // Maps to Section
  parmDocumentFor?: string; // Maps to parmDocumentFor
  processName?: string; // Maps to ProcessName
  documentType?: string; // Maps to DocumentType
}



export class CategoryModel {
  VendorID?: string;
  CategoryID?: string;
  PrimaryID?: string;
}



export class ManagementTeamModel {
  VendorID?: string;
  FirstName?: string;
  LastName?: string;
  Title?: string;
  Email?: string;
  LandlineNumber?: string;
  MobileNumber?: string;
}

export class AssociatedCompanyModel {
  VendorID?: string;
  CompanyName?: string;
  ContactPerson?: string;
  ContactNumber?: string;
  EmailAddress?: string;
  companyType?: string;
  ContactNumberCode? : string;
}

export class SubCategoryModel {
  VendorID?: string;
  SubCategoryID?: string;
  PrimaryID?: string;
}


export class BankAccountModel {
  name: string = '';
  accountNumber: string = '';
  bankIBAN: string = '';
  swift: string = '';
  branch: string = '';
  beneficiaryName: string = '';
  email: string = '';
  address: string = '';
  currencyCode: string = '';
  activeDate: string = '';
  expiryDate?: string;
  sortCode?: string;
  Document?: any; // Assuming Document is either an object or an array of documents (adjust type as needed)
  Documents?:  DocumentModel[];
  bankCertificate?: any;
  otherBankName? : string;
  bankCountry: string = '';
}

export class VendorModel {
  ERPVendorID? : string;
  Email?: string;
  localOrForeign?: string;
  ConfirmPassword?: string;
  Country?: string;
  FirstName?: string;
  LastName?: string;
  Password?: string;
  vendorReference?: string;
  RegisteredInQNBN?: string;
  SignInAs?: string;
  vendorType?: string;
  website?: string;
  mobile?: string;
  vendorName?: string;

  VendorID?: string;
  Mobile?: string;

  OTP?: string;
  OTPExpiry?: Date;
  AddressDescriptionPrimary?: string;
  AddressDescriptionSecondary?: string;
  StreetPrimary?: string;
  StreetSecondary?: string;
  CityPrimary?: string;
  CitySecondary?: string;
  CountryRegionIdPrimary?: string;
  CountryRegionIdSecondary?: string;
  Currency?: string;

  IndividualCompany?: string;
  IsInvestor?: string;
  LocalOrForeign?: string;
  IsMoreThanOneOfficeBranch?: string;

  MethodOfPayment?: string;
  NoOfYears?: string;
  NumberofBranches: number = 0;
  Organizationalstructure?: string;
  noOfEmployees?: string;
  PhonePrimary?: string;
  PhoneSecondary?: string;
  VendorReference?: string;
  RegisteredDate?: string;
  RegistrationDate?: Date;
  TermsOfPayment?: string;
  VendorHold?: string;
  VendorName?: string;
  Status?: string;
  WorkingCapital?: string;
  ZipCodePrimary?: string;
  ZipCodeSecondary?: string;
  identificationDetails? : IdentificationList[];
  contactPerson? : ContactPersonModel[];
  Attachments?: DocumentModel[];
  Category?: CategoryModel[];
  ManagementTeam?: ManagementTeamModel[];
  AssociatedCompanies?: AssociatedCompanyModel[];
  SubCategory?: SubCategoryModel[];
  financeEmail?: string;
  



  BankAccount?: BankAccountModel; // If the vendor can have multiple bank accounts


}

export class IdentificationList {
  vendorID?: string;
  identificationNumber?: string;
  identificationType?: string;
  issuingCountry?: string;
  expiryDate?: Date;
  issuedDate?: Date;
}


export class ContactPersonModel {
  firstName: string = '';
  lastName: string = '';
  title: string = '';
  email: string = '';
  landlineNumber: string = '';
  mobileNumber: string = '';
}



export class BidModel {
  bidID?: string; // Unique identifier for the bid
  status?: string; // Status of the bid
  bidValue?: number | null; // Value of the bid (can be null)
  extendedDate?: Date | null; // Extended date (can be null)
  bidValidUntil?: Date | null; // Validity of the bid (can be null)
  vendorID?: string; // Vendor ID
  tenderID?: string; // Tender ID
  bidClosingDate?: Date; // Closing date of the bid
  bidStartDate?: Date; // Start date of the 
  canSubmit?: boolean; // Start date of the 
  tender? : TenderModel;
  attachments?: DocumentModel[];
}



  export class TenderModel {
    tenderID!: string;
    referenceNo?: string;
    startDate?: Date;
    closureDate?: Date;
    status?: string;
    publishDate?: Date;
    typeofTender?: string;
    bankName?: string;
    extendedDate?: Date;
    managedBy?: string;
    contactPhone?: string;
    contactEmail?: string;
    contactAddress?: string;
    description?: string;
    entity?: string;
    joiningFee? : number;
    evaluationForm?: evaluationForm[];
    documents?: any[];
    vendorTenderParticipation: VendorTenderParticipation = new VendorTenderParticipation();
    tenderClassification?: string;
    isTenderBondRequired? : boolean;
    isPerformanceBondRequired? : boolean;
    isJoiningFeeRequired? : boolean;
    action? : string;
    bidID? : string;
    bidClosureDate? : string;
    

    // Uncomment these lines if you need to include the vendor information
    // vendorID!: number;
    // vendor!: Vendor;
  }


  export class VendorTenderParticipation {

    tenderID?: string | null = null;
    vendorID?: string | null = null;
    firstTimeView?: boolean = false;
    firstTimeViewDate?: Date | null = null;
    joiningFee?: number | null = null;
    accountNumber?: string | null = null;
    action?: string | null = null;
    bankName?: string | null = null;
    isFeepaid?: boolean = true;
    modifiedDate?: string | null = null;
    paymentDate?: Date | null = null;
    paymentReferenceNumber?: string | null = null;
    primaryID?: string | null = null;

 
}

  
  export class Attachment {
    name: string = '';
    description: string = '';
    date: Date = new Date();
    url: string = '';
    attachmentFor: string = '';
    fileContent : string = '';
    additionalDetails:string = '';
    mimeType : string = '';
  }

  

  // evaluation.model.ts
  export class evaluationForm {
    tenderID?: string;
    vendorID?: string;
    bidID?: string;
    serialNo?: number;
    parameter?: string;
    maximumMark?: number;
    marksScored?: number;
  }


   export interface VendorDto extends BaseEntity{
    vendorID: string;  // Required field

    mobile?: string;
    email?: string;
    password?: string;
    ERPVendorID?: string;
    otp?: string;  // MaxLength(200)
    otpExpiry?: Date;
    contactPerson? : ContactPersonModel[];

    addressDescriptionPrimary?: string;
    addressDescriptionSecondary?: string;
    streetPrimary?: string;
    streetSecondary?: string;

    attachments?: DocumenDto[];  // NotMapped in C#
    category?: Category[];  // NotMapped in C#

    cityPrimary?: string;
    citySecondary?: string;

    countryRegionIdPrimary?: string;
    countryRegionIdSecondary?: string;
    currency?: string;
    firstName?: string;
    individualCompany?: string;
    isInvestor?: string;
    localOrForeign?: string;
    isMoreThanOneOfficeBranch?: string;
    lastName?: string;

    managementTeam?: ManagementTeam[];  // NotMapped in C#

    methodOfPayment?: string;
    noOfYears?: string;
    numberofBranches?: number;

    associatedCompanies?: AssociatedCompany[];  // NotMapped in C#

    organizationalstructure?: string;
    noOfEmployees?: string;
    phonePrimary?: string;
    phoneSecondary?: string;
    vendorReference?: string;

    registeredDate?: string;  // NotMapped in C#

    registrationDate?: Date;

    subCategory?: SubCategory[];  // NotMapped in C#

    termsOfPayment?: string;
    vendorHold?: string;
    vendorName?: string;
    status?: string;
    workingCapital?: string;
    zipCodePrimary?: string;
    zipCodeSecondary?: string;

    vendorType?: string;
    emailForCommunication?: string;
   }

  // export class VendorDto {
  //   vendorID!: number;

  //   vendorName?: string;
  //   legalName?: string;
  //   companyNumber?: string;
  //   companyType?: string;
  //   businessType?: string;
  //   contactPerson?: string;
  //   mobile?: string;
  //   email?: string;
  //   password?: string;
  //   secondaryPhone?: string;
  //   primaryAddress?: string;
  //   secondaryAddress?: string;
  //   incorporationDate?: Date;
  //   natureOfBusiness?: string;
  //   methodOfPayments?: string;
  //   companyRegistrationNumber?: string;

  //   estimatedAnnualRevenue?: number; // Angular/TypeScript doesn't have a specific 'decimal' type; number is used instead.

  //   businessRegExpiryDate?: Date;
  //   goodsAndServices?: string;
  //   natureOfBusinessOther?: string;
  //   attachment1?: string;
  //   attachment2?: string;
  //   taxCardDocument?: string;
  //   commercialRegistry?: string;
  //   certificateOfIncorporation?: string;
  //   memorandumOfAssociation?: string;
  //   boardResolution?: string;

  //   taxCardDocExpiry?: Date;
  //   commercialRegExpiryDate?: Date;
  //   certificateOfIncorpExpiryDate?: Date;
  //   memorandumExpiryDate?: Date;
  //   boardResolutionExpiryDate?: Date;

  //   insuranceDocument?: string;
  //   insuranceExpiryDate?: Date;

  //   otp?: string;
  //   otpExpiry?: Date;

  //   status?: number;
  //   referenceNumber?: string;

  //   vendorType?: string; // Added column for Vendor Type
  //   localOrForeign?: string; // Added column for Local or Foreign
  //   singlePointOfContact?: string; // Added column for Single Point of Contact

  //   country?: string;
  //   emailForCommunication?: string;

  //   // primary address
  //   primaryStreet?: string;
  //   primaryPostalCode?: string;
  //   primaryCity?: string;
  //   primaryCountry?: string;

  //   // secondary address
  //   secondaryStreet?: string;
  //   secondaryPostalCode?: string;
  //   secondaryCity?: string;
  //   secondaryCountry?: string;
  // }
  export interface BaseEntity {
    id: number;  // Key field, auto-generated

    createdAt?: Date;  // Column("CreatedAt") in C#
    createdDate?: string;  // NotMapped in C#
    createdBy?: string;  // Default value: "ERP"

    modifiedAt?: Date;  // Column("ModifiedAt") in C#
    modifiedDate?: string;  // NotMapped in C#
    modifiedBy?: string;  // Default value: "ERP"

    primaryID?: string;  // NotMapped in C#
  }

  export interface DocumenDto extends BaseEntity {
    processName?: string;
    attachmentFor?: string;
    attachmentId?: string;

    expiryDate?: string;  // NotMapped in C#
    documentExpiryDate?: Date;  // Column("ExpiryDate") in C#

    additionalDetails?: string;
    applicationId?: string;
    name?: string;
    filePath?: string;

    fileContent?: string;  // NotMapped in C#

    recId: number;
    isIntegrated: boolean;
  }
  export interface Category extends BaseEntity {
    vendorID?: string;
    categoryID?: string;
  }

export interface ContactPerson extends BaseEntity {
  vendorID?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  email?: string;
  landlineNumber?: string;
  mobileNumber?: string;
}

export interface ManagementTeam extends BaseEntity {
  vendorID?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  email?: string;
  landlineNumber?: string;
  mobileNumber?: string;
}

export interface AssociatedCompany extends BaseEntity {
  vendorID?: string;
  companyName?: string;
  contactPerson?: string;
  contactNumber?: string;
  emailAddress?: string;
}

export interface SubCategory extends BaseEntity {
  vendorID?: string;
  subCategoryID?: string;
}

  export class BankAccount {
    id: number = 0;
    bankID: string = '';
    name: string = '';
    forignBankName: string = '';
    bankType: number = 0;
    bankIBAN: string = '';
    swiftCode: string = '';
    branchName: string = '';
    benficeryName: string = '';
    activeFrom: Date = new Date();
    countryID: number = 0;
    bankDocument: string = '';
    vendorID: number = 0;
    addedOn: Date = new Date();
    lastModification: Date = new Date();
    expiryDate?: Date;
    accountNumber?: string;
    bankStatus?: number;
    sortCode?: string;
    email?: string;
    address?: string;
    currency?: string;
    ActiveDate : Date = new Date();
    ExpiryDate : Date = new Date();
    TheDocuments : TheDocuments[] = []; 
    otherBankName? : string;
    bankCountry? : string;
    
  }

  export interface TheDocuments {
    attachmentId?: string;
    fileName?: string;
    fileContent?: string;  // This will be the Base64-encoded string representing the file content
    filePath?: string;
    expiryDate?: Date;
}

  

export class LoginOTPDTO {
  Email: string;
  OTP: string;
  Action: AuthenticationActions;
  Data: any; // You can use 'any' to support various types of data

  constructor(email: string, otp: string, action: AuthenticationActions, data?: any) {
    this.Email = email;
    this.OTP = otp;
    this.Action = action;
    this.Data = data || {}; // Default to an empty object if no data is provided
  }
}


// export class FamilyDTO {
//     Name: string;
//     MobileNumber: string;
//     Gender: number;
//     Area: number;
//     ProjectName: number;
//     CraftCategory: string;
//     Craft: string;
//     CraftCategoryNotes: string | null;
//     Email: string | null;
//     QId: string;
//     Nationality: number;
//     DateofBirth: Date;
//     ReceiveSalaryFromSocialSecurity: boolean | null;
//     InstaAccount: string | null;
//     MaritalStatus: number | null;
//     AccomodationType: null | number;
//     EmploymentStatus: boolean | null;
//     EducationLevel: number | null;
//     NumberofFamilyMembers: null | number;
//     DoYouFoodCartorCookCart: boolean | null;
//     IncomeSource: number | null;
//     TypeofLicense: number | null;
//     FamilyStatus: null | number;
//     ParticipateInTrainingCourses: boolean | null;
//     WhatAretheChallanges: string | null;
//     FamilyParticipations: string | null;
//     CopyofQId: any | null;
//     CopyofCR: any | null;
//     CertificateCopy: any | null;
//     Members: Array<any> | null;
//     Workers: Array<any> | null;
//     street: string | null;
//     zone: string | null;
//     poBox: string | null;
//     building: string | null;
//     copyofId: any | null;
//     copyofCR: any | null;
//     copyofCertificate: any | null;
//     idExpiryDate: string | null;
//     cpNumber: string | null;
//     commercialRecordEndDate: Date | null;
//     medicalCommissionTestDate: Date | null;
//     medicalCommissionRequestNumber: string | null;
// }
// export class RequestDTO {
//     IdExpiryDate: string;
//     ServiceId: string;
//     DepartmentId: string;
//     RelativePhone: string;
//     Municipality: string;
//     Region: string;
//     RegionNumber: string;
//     // StreetName: string;
//     StreetNumber: string;
//     ApartmentNumber: string;
//     // PostalCode: string;
//     // FaxNumber: string;
//     // HomeNumber: string;
//     IdImage: any | null;
//     Id2: any | null;
//     Id3: any | null;
//     Id4: any | null;
//     Id5: any | null;
//     Id6: any | null;
// }
// export class Craft {
//     id: string;
//     name: string;
//     category: string;
// }
// export class CraftCategoryItem {
//     id: string;
//     name: string;
//     isFAndBCraft: boolean | null;
//     commericalRecord: boolean | null;
//     crafts: Array<Craft>;
// }
// export class NationalityLookupItem {
//     id: string;
//     name: string;
//     code: string;
// }
// export class MunicipalityLookupItem {
//     id: string;
//     name: string;
// }
// export class RegionLookupItem {
//     id: string;
//     name: string;
//     msdfch_MunicipalityId: string;
//     regionNumber: string;
// }
// export class FileRequest {
//     TypeAttachment: string;
//     File: any;
// }
// export class FamilyDependencies {
//     categories: Array<CraftCategoryItem>;
//     nationalitiesLookup: Array<NationalityLookupItem>;
// }
// export enum Mode {
//     Create = 1,
//     Edit
// }
// export class Option {
// }
// export class Family {
//     name: string;
//     qId: string;
//     email: string;
//     mobileNumber: string;
//     nationality: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null };
//     gender: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null };
//     dateofBirth: string;
//     craftCategory: { id: string; description: string | null };
//     craft: { id: string; description: string | null };
//     craftCategoryNotes: string | null;
//     educationLevel: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     maritalStatus: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     area: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null };
//     instaAccount: string | null;
//     receiveSalaryFromSocialSecurity: boolean | null;
//     numberofFamilyMembers: number | null;
//     employmentStatus: boolean | null;
//     accomodationType: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     participateInTrainingCourses: boolean | null;
//     typeofLicense: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     incomeSource: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     doYouFoodCartorCookCart: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     familyStatus: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null } | null;
//     whatAretheChallanges: string | null;
//     familyParticipations: string | null;
//     projectName: string;
//     members: Array<{ id: string; qId: string; idExpiryDate: Date | null; name: string; requestNumber: string | null; testDate: Date | null; nationality: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null }; gender: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null }; copyofId: { attachmentId: string, isModified: boolean } }>;
//     workers: Array<{ id: string; qId: string; idExpiryDate: Date | null; name: string, requestNumber: string | null; testDate: Date | null; nationality: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null }; gender: { id: number; description: string | null; descriptionEn: string | null, descriptionAr: string | null }; copyofId: { attachmentId: string, isModified: boolean } }>;
//     copyofCR: { attachmentId: string, isModified: boolean };
//     copyofCertificate: { attachmentId: string, isModified: boolean } | null;
//     copyofId: { attachmentId: string, isModified: boolean };
//     zone: string | null;
//     building: string | null;
//     street: string | null;
//     poBox: string | null;
//     idExpiryDate: string | null;
//     cpNumber: string | null;
//     commercialRecordEndDate: Date | null;
//     medicalCommissionTestDate: string | null;
//     medicalCommissionRequestNumber: string | null;
//     isCountedOn: string | null;
//     husbandNationality: string | null;
//     hasChildren: string | null;
//     husbandID: string | null;
//     socialSituation: string | null;
//     marriageDate: string | null;
//     employerPhoneNumber: string | null;
//     job: string | null;
//     employer: string | null;
//     salary: string | null;
//     retirementEntity: string | null;
//     zoneName: string | null;
//     electNumber: string | null;
//     relativeNumber: string | null;
// }

// export class ItemDto {
//     id: string;
//     description: string;
//     descriptionEn: string;
//     descriptionAr: string;
// }
// export class ExtraItemDto {
//     id: string;
//     logicalName: string;
//     name: string;
//     keyAttributes: any[];
//     rowVersion: string;
//     extensionData: {};
// }
// export class UserDetailsDto {
//     id: string;
//     alive: boolean;
//     beneficiary: ItemDto;
//     beneficiaryName: string;
//     dateOfBirth: string;
//     breadwinner: ItemDto;
//     buildingNo: string;
//     createdOn: string;
//     email: string;
//     idExpiryDate: string;
//     fullName: string;
//     gender:ItemDto;
//     haveSons: ItemDto;
//     iban: string;
//     idCopy: string;
//     idNumber: string;
//     job: string;
//     jobStatus: ItemDto;
//     maritalStatus: ItemDto;
//     mariageDate: string;
//     modifiedOn: string;
//     municipality: ExtraItemDto;
//     nationality: ExtraItemDto;
//     oldId: string;
//     oldPHRId: string;
//     oldRegion: string;
//     postOffice: string;
//     mobileNumber: string;
//     recordCreatedOn: string;
//     region: ExtraItemDto;
//     regionNumber: string;
//     relationType: string;
//     realtivePhoneNumber: string;
//     retirementDate: string;
//     retirementPlace: string;
//     salary: string;
//     streetNumber: string;
//     swiftCode: string;
//     workPhone: string;
//     workPlace: string;
// }

// export class Details {
//     // code: number | null;
//     addressDesc: string | null;
//     buildingNum: string | null;
//     email: string | null;
//     mobileNumber: string | null;
//     postBoxNum: string | null;
//     qId: string | null;
//     streetNameAr: string | null;
//     streetNameEn: string | null;
//     streetNum: string | null;
//     telephoneNumber: string | null;
//     unitNum: string | null;
//     zoneNum: string | null;
// }
// export class BeneficiaryDetails {
//     qId: string | null;
//     beneficiaryName: string | null;
//     payments: Array<any> | null;
//     work: boolean | null;
// }
// export class SocialSecurity {
//     qid: string | null;
//     statusCode: number | null;
//     beneficiaryStatus: boolean | null;
// }
// export class MOCIIntegrationResponse {
//     endDate: string;
// }
